/**
 * exercise-edit-goal.js
 */

import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Types } from 'utils/constants';
import analytics from 'utils/analytics';
import { shouldRenderMobileLayout } from 'utils/app-context';
import { EditorIconSection } from 'components/icon-section/icon-section';
import HelpTextItem from 'components/menu-drawer/help-text-item';
import EditorAccordion from 'components/menu-drawer/editor-accordion';
import FormSectionTitle from 'components/menu-drawer/form-section-title';
import EditorTextTemplates from 'components/editor-text-templates';
import TextField from 'components/form-inputs/text-field';


export default function ExerciseEditGoal(props) {
  const {
    drawerState,
    translation,
    options,
  } = props;
  const { t } = useTranslation(translation);
  const { control, getValues, setValue } = useFormContext();
  const workModeValue = useWatch({ control, name: 'workMode' });

  return (
    <>
      <EditorIconSection
        iconName='description'
        iconMarginTop={24}
        helpProps={{
          translation,
          section: 'description'
        }}
      >
        {/* exercise goal */}
        <HelpTextItem
          sidebarText={drawerState.sidebarText}
          title={t('description.goal.helpTitle')}
          text={t('description.goal.helpInfo')}
          data-testid="exercise-goal-field"
        >
          {focusHandlers =>
          <>
            <EditorTextTemplates
              recent={options.recentEntries.goal}
              translation={translation}
              samplesTranslationKey='description.goal.templates'
              onSelect={value => {
                analytics.trackGA4('event', { name: 'record_template', params: { record_type: 'exercise', template_type: 'goal' } });
                let currValue = getValues('goal');
                currValue = currValue.replace('<Not Specified>', '');
                const newValue = `${currValue}${currValue ? '\n\n' : ''}${value}`;
                setValue('goal', newValue, { shouldDirty: true });
              }}
            />
            <TextField
              name='goal'
              label={t('description.goal.label')}
              focusHandlers={focusHandlers}
              multiline
            />
          </>}
        </HelpTextItem>

        {/* description - optional */}
        {workModeValue === Types.WorkMode.PATROL &&
        <EditorAccordion
          highlight
          name='Description Optional'
          data-testid='exercise-optional-accordion'

          summary={<>
            <FormSectionTitle
              style={shouldRenderMobileLayout() ? { marginLeft: '32px' } : {}}
            >
              {window.innerWidth < 450 ? 'Optional Fields' : 'OPTIONAL: Description'}
            </FormSectionTitle>
          </>}

          detail={<>
            <HelpTextItem
              sidebarText={drawerState.sidebarText}
              title={t('description.description.helpTitle')}
              text={t('description.description.helpInfo')}
            >
              {focusHandlers =>
              <>
                <EditorTextTemplates
                  recent={options.recentEntries.description}
                  translation={translation}
                  samplesTranslationKey='description.description.templates'
                  onSelect={value => {
                    analytics.trackGA4('event', { name: 'record_template', params: { record_type: 'exercise', template_type: 'description' } });
                    const currValue = getValues('description');
                    const newValue = `${currValue}${currValue ? '\n\n' : ''}${value}`;
                    setValue('description', newValue, { shouldDirty: true });
                  }}
                />
                <TextField
                  name='description'
                  label={t('description.description.label')}
                  focusHandlers={focusHandlers}
                  multiline
                />
              </>}
            </HelpTextItem>
          </>}

        />}

      </EditorIconSection>
    </>
  );
}